import { SCENE_HEIGHT, STREET_Y } from '../shared/sceneDimensions';

/** Shared visual scaffold. Camera/framing belongs to the calling view. */
export function SceneBackdropDefinitions() {
  return <>
    <linearGradient id="sky" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2={SCENE_HEIGHT}><stop stopColor="#c9d1cd"/><stop offset="1" stopColor="#eee7d9"/></linearGradient>
    <linearGradient id="road" gradientUnits="userSpaceOnUse" x1="0" y1="655" x2="0" y2={SCENE_HEIGHT}><stop stopColor="#5d6864"/><stop offset="1" stopColor="#354743"/></linearGradient>
  </>;
}

export default function SceneBackdrop({x,width,layer,sceneTop=0,sceneHeight=SCENE_HEIGHT}:{x:number;width:number;layer:'sky'|'ground';sceneTop?:number;sceneHeight?:number}) {
  if(layer==='ground')return <>
    <rect x={x} y={STREET_Y} width={width} height="54" fill="#aaa999"/>
    <path d={`M${x} 651H${x+width}`} stroke="#d6d1bc" strokeWidth="6"/>
    <rect x={x} y="655" width={width} height={Math.max(105,sceneTop+sceneHeight-655)} fill="url(#road)"/>
  </>;
  // Cull by absolute tile identity: recycling a screen slot must never change
  // the building already at a world position. Keep the existing three-roof motif.
  const firstTile=Math.floor(x*.28/240)-1,lastTile=Math.ceil((x*.28+width)/240)+1;
  return <>
    <rect x={x} y={Math.min(0,sceneTop)} width={width} height={Math.max(SCENE_HEIGHT,sceneTop+sceneHeight)-Math.min(0,sceneTop)} fill="url(#sky)"/>
    <circle cx={x*.88+width*.76} cy="120" r="64" fill="#eee9d3" opacity=".65"/>
    <g transform={`translate(${x*.72},0)`} opacity=".37">
      {Array.from({length:lastTile-firstTile+1},(_,index)=>{const tile=firstTile+index,at=tile*240,roof=150+((tile%3+3)%3)*30;return <g key={tile} data-skyline-tile={tile}><rect x={at} y={roof} width="155" height="430" fill="#879991"/>{[0,1,2,3].map(row=><path key={row} d={`M${at+18} ${200+row*54}h18m18 0h18m18 0h18m18 0h18`} stroke="#bac8bd" strokeWidth="17"/>)}<rect x={at+115} y={roof-70} width="25" height="70" fill="#8d9e96"/></g>;})}
    </g>
    <path d={`M${x} 204Q${x+width/2} 250 ${x+width} 200`} stroke="#74817b" strokeWidth="1.5" fill="none" opacity=".5"/>
  </>;
}
